import type { ReactNode } from 'react';

type FlipCardProps = {
  back: ReactNode;
  front: ReactNode;
  isFlipped: boolean;
  onClick: () => void;
};

export const FlipCard = ({
  back,
  front,
  isFlipped,
  onClick
}: FlipCardProps) => (
  <div
    className="relative size-52 cursor-pointer"
    onClick={onClick}
    style={{ perspective: '1000px' }}
  >
    <div
      className="size-full transition-transform duration-500"
      style={{
        position: 'relative',
        transformStyle: 'preserve-3d',
        transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
      }}
    >
      <div
        className="absolute inset-0 flex size-full items-center justify-center"
        style={{ backfaceVisibility: 'hidden' }}
      >
        {front}
      </div>
      <div
        className="absolute inset-0 flex size-full items-center justify-center"
        style={{
          backfaceVisibility: 'hidden',
          transform: 'rotateY(180deg)'
        }}
      >
        {back}
      </div>
    </div>
  </div>
);
